export default __webpack_public_path__ + "static/Progressive-Web-Apps-c1e30a8f8f173e1bca4044d16946632a.jpg";